import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTroubleshooting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 67 64"
    {...props}
  >
    <path
      stroke="#4B7EFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m22 28.667 10 10L65.333 5.333M45.333 2H18C12.4 2 9.6 2 7.46 3.09a10 10 0 0 0-4.37 4.37C2 9.6 2 12.4 2 18v28c0 5.6 0 8.4 1.09 10.54a10 10 0 0 0 4.37 4.37C9.6 62 12.4 62 18 62h28c5.6 0 8.4 0 10.54-1.09a10 10 0 0 0 4.37-4.37C62 54.4 62 51.6 62 46V32"
    />
  </svg>
);
export default SvgTroubleshooting;
